export default __webpack_public_path__ + "static/media/art-brw-3.e5660f6d.png";